module.exports = __webpack_public_path__ + "img/logo.d456480b.png";